import React from "react";

import { Container, ArrowUpContainer, ArrowUp, TextContainer } from "./styles";

//Interfaces
import { TooltipPropsInterface } from "./interfaces"

const Tooltip = (props: TooltipPropsInterface) => {
    return(

        // <Wrapper>
            <Container >
                {props.text
                    ? <>
                        <ArrowUp/>
                        <TextContainer className={props.className} margin={`-${props.margin}px`}>{props.text}</TextContainer>
                    </>
                    : props.overlay
                }
            </Container>
        // </Wrapper>
    )
}

export default Tooltip;